/**
 * Changes made:
 * - 2025-09-27: Created RightBackgroundVector component for hero section right-side vector shape
 */

export const RightBackgroundVector = () => {
  return (
    <div 
      data-svg-wrapper 
      data-layer="Vector 5" 
      className="Vector5 left-[755.50px] top-0 absolute"
    >
      <svg width="602" height="539" viewBox="0 0 602 539" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M602 0H270.886L0.5 474.38H69L322 44.5L602 539V0Z" fill="hsl(var(--hero-vector-right))" />
      </svg>
    </div>
  );
};